import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { clientEnvs } from '@/config/client-envs';
import { logger } from '@/lib/observability/logger';
export const MORPHO_SDK_VERSION: string = clientEnvs.NEXT_PUBLIC_MORPHO_SDK_VERSION!;
const loggedErrors = new Set<string>();
export function logSdkBuildFailed({
  sdkAction,
  chainId,
  reviewSessionId,
  error
}: {
  sdkAction: string;
  chainId: number;
  reviewSessionId: string;
  error: unknown;
}): void {
  const errorName = error instanceof Error ? error.name : 'UnknownError';
  const errorCode = typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'string' ? error.code : undefined;
  const dedupeKey = `${reviewSessionId}:${sdkAction}:${errorName}:${errorCode ?? ''}`;
  if (loggedErrors.has(dedupeKey)) return;
  loggedErrors.add(dedupeKey);
  logger.info({
    event: 'sdk_build_failed',
    sdk_action: sdkAction,
    sdk_version: MORPHO_SDK_VERSION,
    chain_id: String(chainId),
    review_session_id: reviewSessionId,
    error_name: errorName,
    ...(errorCode === undefined ? {} : {
      error_code: errorCode
    })
  });
}
export function useLogSdkBuildFailed(t0) {
  const $ = _c(6);
  const {
    sdkAction,
    chainId,
    reviewSessionId,
    error
  } = t0;
  let t1;
  let t2;
  if ($[0] !== chainId || $[1] !== error || $[2] !== reviewSessionId || $[3] !== sdkAction) {
    t1 = () => {
      if (!error || chainId === undefined) {
        return;
      }
      logSdkBuildFailed({
        sdkAction,
        chainId,
        reviewSessionId,
        error
      });
    };
    t2 = [chainId, error, reviewSessionId, sdkAction];
    $[0] = chainId;
    $[1] = error;
    $[2] = reviewSessionId;
    $[3] = sdkAction;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
}